import { Alert } from '@mui/material';
import { colors } from '@/theme';

export default function MaintenanceBanner({ message = '' }) {
  return (
    <Alert
      variant="filled"
      severity="warning"
      sx={{
        backgroundColor: colors.warning.dark,
        borderRadius: 0,
        width: '100%',
        marginBottom: '0px',
        fontSize: '16px',
        '@media (max-width: 540px)': {
          fontSize: '12px',
        },
      }}
    >
      {message}
    </Alert>
  );
}
